export class Observable<T> {
  private cbArr: ((value: T) => void)[] = [];

  private value: T;

  constructor(_value: T) {
    this.value = _value;
  }

  getValue(): T {
    return this.value;
  }

  next(value: T): void {
    this.value = value;
    for (const cb of this.cbArr) {
      cb(value);
    }
  }

  subscribe(cb: (value: T) => void) {
    this.cbArr.push(cb);

    return cb;
  }

  unsubscribe(cb: (value: T) => void): void {
    this.cbArr = this.cbArr.filter((cbItem) => cbItem !== cb);
  }
}
